<template>
  <div class="fill-height primary">
    <v-content class="fill-height">
      <v-layout align-center justify-center row wrap fill-height>
        <v-flex
          xs12
          layout
          align-center
          justify-center
          pa-3
        >
          <v-container fluid grid-list-xs class="pa-2">
            <v-layout row wrap>
              <v-flex xs12 sm12 offset-md3 md6 offset-lg4 lg4>
                <v-card class="pl-4 pr-4 pb-4 pt-0 elevation-5">
                  <v-card-title primary-title>
                    <v-container grid-list-md class="pa-0">
                      <v-layout row wrap>
                        <v-flex
                          xs12
                          text-xs-center
                          layout
                          align-center
                          justify-center
                        >
                          <v-avatar
                            size="150"
                            color="white"
                            tile
                          >
                            <img :src="logoUrl">
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-title>
                  <h1 class="title text-xs-center font-weight-bold mb-4">Logging in as seller</h1>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}

.fill-height {
  height: 100%;
}

.fill-width {
  width: 100%;
}

.pa-3 {
  padding: 5px;
}

</style>

<script>
import router from '../router'
import Loading from '@/components/Loading.vue'

export default {
  props: [
    'loginToken'
  ],
  components: {
    Loading
  },
  data () {
    return {
      logoUrl: process.env.VUE_APP_LOGO_URL,
      loading: false
    }
  },

  mounted () {
    this.setToken(this.loginToken)
  },

  methods: {
    setToken: function (loginToken) {
      this.loading = true
      this.$store.dispatch('AUTH_LOGIN_TOKEN', { loginToken }).then(() => {
        router.push('/')
        this.loading = false
      }).catch((e) => {
        this.loading = false
      })
    }
  }
}
</script>
